import React from 'react';
import {useTypedSelector} from '@common/hooks/useTypedSelector';
import ProjectPageTags from '@modules/Projects/components/ProjectPageTags';
import ProjectGrid from '@common/components/ProjectGrid';
import ProjectTimeLine from '@modules/Projects/components/ProjectTimeLine';
import Text from '@common/components/common/Text';


export const Projects = () => {
  const {projectsPage, projectsWithImages = [], projectsSortByDate = []} = useTypedSelector(state => state.projects);

  return (
    <div>
      <section className="portfolio">
        <div className="container">
          <h1 className="portfolio__title">
            <Text text={projectsPage?.title}/>
          </h1>
          <div className="portfolio__filter">
            <ProjectPageTags tags={projectsPage?.tags || []}/>
          </div>
          <div className="project">
            <ProjectGrid projects={projectsWithImages}/>
            <ProjectTimeLine projects={projectsSortByDate}/>
          </div>
        </div>
      </section>
    </div>
  )
}
